<script setup>
import { defineProps, toRefs } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  url: {
    type: String,
    required: true,
  },
  allowDownload: {
    type: Boolean,
    default: true,
  },
  dataTestid: {
    type: String,
    default: "my-students-submission-current-document-pdf",
  },
});

const emit = defineEmits(["error"]);

const { name, url, allowDownload, dataTestid } = toRefs(props);
</script>

<template>
  <div v-if="url" class="break-all items-center cursor-pointer">
    <a v-if="allowDownload" :href="url" target="_blank" rel="noopener noreferrer">
      <img :src="url" :alt="name" :data-testid="dataTestid" @error="emit('error')" />
    </a>
    <div v-else>
      <img :src="url" :alt="name" :data-testid="dataTestid" @error="emit('error')" />
    </div>
  </div>
</template>
